module.exports = __webpack_public_path__ + "img/pretzel.b97fe984.svg";